import './variableBinding.less';

import React from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';

import { AntSelect } from 'controls/react/ant/ant-select/antSelect';

import { getVariableChoices } from './utils/getVariableChoices';
import { isVariableSuitable } from './utils/isVariableSuitable';
import { VariableLabel } from './components/variable-label/variableLabel';
import { VariablePicker } from './components/variable-picker/variablePicker';
import { VariableBindingProps } from './types';

const b = b_.with('variable-binding');

export const VariableBinding = observer(
	({ variables, type, variableId, onVariableChange, children, ...entryProps }: VariableBindingProps) => {
		// what a FormEntryNew hands to the element in it is meant for the field
		const field = React.cloneElement(children, entryProps);
		if (variables == null || variableId == null) {
			return (
				<VariablePicker variables={variables} type={type} list={false} onPick={onVariableChange}>
					{field}
				</VariablePicker>
			);
		}

		const variable = variables.find((x) => x.id == variableId);
		const options = getVariableChoices(variables, type, false).map((choice) => ({
			value: choice.variable.id,
			label: <VariableLabel variable={choice.variable} />,
			name: choice.variable.name,
			disabled: !choice.suitable,
		}));

		return (
			<AntSelect
				className={b()}
				value={variableId}
				options={options}
				optionFilterProp={'name'}
				status={variable == null || !isVariableSuitable(variable, type, false) ? 'error' : undefined}
				labelRender={() => <VariableLabel variable={variable} />}
				allowClear={true}
				onChange={(id: string | undefined) => onVariableChange(id ?? null)}
			/>
		);
	},
);
